import { elapsed, workVia, type BoardItem } from "@boem/core/shared";
import "../claude.css";

/** "Rohit · working via Claude Code · 40 min" for each open work session on the item. */
export function Working({ it }: { it: BoardItem }) {
  if (!it.sessions?.length) return null;
  return (
    <div className="working">
      {it.sessions.map((s) => (
        <div
          key={s.id}
          className="working-line"
          title={[s.branch ? `Branch ${s.branch}` : null, s.lastProgress ? `Latest: ${s.lastProgress}` : null, `Last update ${elapsed(s.lastProgressAt)} ago`]
            .filter(Boolean)
            .join("\n")}
        >
          <span className="working-dot" aria-hidden="true" />
          <b>{s.member}</b>
          <span>&middot; working via {workVia(s)}</span>
          <span>&middot; {elapsed(s.startedAt)}</span>
          {s.percent != null && <span>&middot; {s.percent}%</span>}
          {s.lastProgress && <span className="working-last">&mdash; {s.lastProgress}</span>}
        </div>
      ))}
    </div>
  );
}
